module.exports = __webpack_public_path__ + "img/g_2018.c0bd858d.jpeg";